import React, { ReactNode } from 'react';

import coreLogger from '../../../utils/log/coreLogger';

export interface AbstractErrorBoundaryProps {
  children?: ReactNode;
  ErrorMessage: React.FC;
}

class AbstractErrorBoundary extends React.PureComponent <AbstractErrorBoundaryProps> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state = {
    hasError: false,
  };

  componentDidCatch(error: Error) {
    try {
      coreLogger.error(error);
    } catch (err) {
      // In IE, it crashes if the dev tool are closed
      coreLogger.warn('AbstractErrorBoundary: An error was thrown inside "componentDidCatch". It may be normal in IE as error boundaries throw when the dev tools are closed', err);
    }
  }

  render() {
    const { hasError } = this.state;
    const { children, ErrorMessage, ...otherProps } = this.props;

    if (hasError) {
      return (
        <ErrorMessage {...otherProps} />
      );
    }

    return children;
  }
}

export default AbstractErrorBoundary;
